import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: null, loading: true });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => setSettings(r.data))
      .catch(() => setSettings(null))
      .finally(() => setLoading(false));
  }, []);

  // Inject admin-managed head/body/footer HTML + favicon + verification
  useEffect(() => {
    if (!settings) return;
    if (settings.favicon_url) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = settings.favicon_url;
    }
    if (settings.head_html) {
      const container = document.createElement("div");
      container.setAttribute("data-admin-head", "true");
      container.innerHTML = settings.head_html;
      Array.from(container.childNodes).forEach((node) => {
        if (node.tagName === "SCRIPT") {
          const s = document.createElement("script");
          Array.from(node.attributes).forEach((a) => s.setAttribute(a.name, a.value));
          s.textContent = node.textContent;
          document.head.appendChild(s);
        } else {
          document.head.appendChild(node.cloneNode(true));
        }
      });
    }
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
